export const errors = {
  404: 'Error: Página no encontrada',
  user_not_active:
    'Comprueba tu correo electrónico y sigue el enlace que te hemos enviado para poder activarte ❗❗ Si no encuentras el email, revisa en la bandeja de Spam por si acaso. A veces cae ahí!',
  email_does_not_exist: 'Aún no has registrado una cuenta con este email. Regístrate para acceder a Familiados',
  title: {
    default: 'Ha ocurrido un error',
    unauthorized: 'Inicia sesión',
    user_not_active: 'No has activado tu cuenta. Comprueba tu email',
    email_does_not_exist: 'No tienes una cuenta con este email',
    invalid_credentials: 'Email o contraseña no válidos',
    invalid_user: 'Inicia sesión',
  },
  mandatory_email: 'El email es obligatorio',
  recurrent_email: 'El email ya ha sido usado anteriormente. Prueba con otro',
  short_email: 'El email es demasiado corto',
  long_email: 'El email es demasiado largo',
  email_in_use_by_guest:
    'Ups! Has lanzado una búsqueda con ese email y ahora no podemos registrarte como profesional. Regístrate con un email diferente o escríbenos a contacto@familiados.com si quieres utilizar este email. Perdona las molestias!',
  wrong_email_format: 'El formato del email es incorrecto',
  mandatory_password: 'Es obligatorio introducir una contraseña',
  short_password: 'Contraseña demasiado corta',
  mandatory_logout_token: 'No se ha podido cerrar la sesión correctamente, falta el token de sesión',
  not_found_logout_token: 'No se ha podido cerrar la sesión correctamente, no se encuentra información de la sesión',
  mandatory_validation_token:
    'El token de activación es obligatorio. Por favor, sigue el enlace que has recibido por correo',
  not_found_validation_token:
    'El token de activación no existe. Por favor, sigue el enlace que has recibido por correo al registrarte',
  not_found_email: 'El email no está registrado',
  mandatory_token: 'Falta el token de validación. Por favor, sigue el enlace que has recibido por correo',
  invalid_token:
    'El enlace usado no es válido. O bien se trata de un enlace ya utilizado, o bien ha tenido lugar un error. Por favor, prueba con un enlace válido',
  deprecated_token:
    'El enlace ha caducado. Se te ha enviado un nuevo correo electrónico con otro enlace. Por favor, sigue este nuevo enlace para restablecer tu contraseña',
  invalid_activation_token: 'El enlace de activación es invalido. Por favor, prueba con un enlace válido',
  mandatory_current_password: 'Falta la contraseña actual',
  incorrect_password: 'La contraseña actual no es correcta',
  password_already_requested:
    'Ya has solicitado un cambio de contraseña. Sigue las instrucciones del correo que te hemos enviado para poder cambiarla',
  mandatory_new_password: 'Falta introducir la nueva contraseña',
  mandatory_new_password_repeat: 'Falta introducir la contraseña repetida',
  invalid_new_password: 'El formato de la nueva contraseña no es correcto',
  different_new_passwords: 'La contraseña nueva y la repetida son diferentes',
  new_password_like_current: 'La nueva contraseña es igual que la actual',
  invalid_credentials: 'Comprueba que has escrito bien tu correo electronico y contraseña',
  caretaker_not_found: 'No ha sido posible encontrar al profesional. Si quieres continuar, vuelve a iniciar sesión',
  caretaker_is_not_active: 'No ha sido posible encontrar al profesional. Es posible que no haya sido activado',
  caretaker_id_not_found: 'No ha sido posible encontrar al profesional. Intentalo más tarde',
  caretaker_has_not_minimum_requirements: 'Necesitas tener activado tu perfil para poder apuntarte a ofertas',
  service_not_found: 'Lo sentimos, no ha sido posible encontrar la oferta.',
  email_in_use: 'Hay otra cuenta registrada con este email',
  mandatory_name: 'El nombre personal es obligatorio',
  short_name: 'El nombre personal es demasiado corto',
  long_name: 'El nombre personal es demasiado largo',
  invalid_image_format: 'El formato de la imagen subida es incorrecto',
  mandatory_profile_image: 'La imagen de perfil es obligatoria',
  profile_image_size: 'El tamaño de la imagen de perfil debe ser menor a 2 MB',
  error_creating_image:
    'Ha habido un error al guardar la imagen en el servidor. Por favor, prueba de nuevo en unos momentos',
  mandatory_surname: 'El apellido es obligatorio',
  mandatory_mobilephone: 'El número de teléfono es obligatorio',
  format_mobilephone: 'El formato del número de teléfono es incorrecto',
  mandatory_gender: 'El género es obligatorio',
  invalid_gender: 'El valor del género no es correcto',
  mandatory_birthdate: 'La fecha de nacimiento es obligatoria',
  invalid_birthdate: 'El valor de la fecha de nacimiento seleccionada no es correcto',
  long_description: 'El tamaño de la descripción no debe superar los 250 caracteres',
  mandatory_latitude: 'No se ha guardado una ubicación correcta. Por favor, vuelve a introducir la ubicación elegida',
  invalid_latitude: 'No se ha guardado una ubicación correcta. Por favor, vuelve a introducir la ubicación elegida',
  mandatory_longitude: 'No se ha guardado una ubicación correcta. Por favor, vuelve a introducir la ubicación elegida',
  invalid_longitude: 'No se ha guardado una ubicación correcta. Por favor, vuelve a introducir la ubicación elegida',
  mandatory_service_time: 'La franja horaria en la que se pueden ofrecer servicios es obligatoria',
  invalid_service_time:
    'Formato de franjas horarias incorrecto. Por favor, vuelve a seleccionar las franjas horarias de servicio',
  mandatory_service_days: 'La selección de días en los que se pueden ofrecer servicios es obligatoria',
  caretaker_availability_service_already_reserved:
    'Servicio reservado. Lo sentimos pero el cliente ha seleccionado a otro profesional',
  caretaker_availability_service_expired: 'Servicio caducado. Lo sentimos pero esta oferta ha caducado',
  recommended_request_not_found:
    'No hay profesionales disponibles. Los profesionales que se habían apuntado ya no están disponibles. Si no te llegan candidatos nuevos, prueba a lanzar una nueva búsqueda!',
  recommendation_service_already_reserved:
    'Servicio reservado. Ya has cerrado la reserva de este servicio. Consulta en tu área privada en el listado de Reservas 😊',
  recommendation_service_expired:
    'Servicio caducado. Lo sentimos pero tu solicitud ha caducado. Prueba a lanzar una nueva búsqueda!',
  invalid_service_days:
    'Formato incorrecto de los días de servicio. Por favor, vuelve a seleccionar los días de servicio',
  mandatory_care_type: 'Es obligatorio elegir al menos un tipo de cuidado',
  invalid_caretype: 'Formato incorrecto de tipos de cuidado',
  mandatory_short_time_rate: 'La tarifa para servicios cortos es obligatoria',
  invalid_short_time_rate: 'El formato de las tarifas de servicios cortas es incorrecto',
  mandatory_long_time_rate: 'La tarifa para servicios largos es obligatoria',
  mandatory_language: 'El idioma de servicio es obligatorio, elige al menos un idioma',
  invalid_long_time_rate: 'El formato de las tarifas de servicios largos es incorrecto',
  mandatory_welcome_rate: 'Selecciona si deseas tener una tarifa de bienvenida o no',
  invalid_welcome_rate:
    'Ha habido un problema con el envío de la tarifa de bienvenida. Por favor, selecciona la opción que deseas',
  mandatory_main_qualification: 'Por favor, selecciona una titulación como principal',
  invalid_main_qualification:
    'El código de titulación principal no es válido. Vuelve a seleccionar una titulación principal',
  mandatory_child_experience: 'Falta marcar al menos un campo de experiencia con niños',
  mandatory_elder_experience: 'Falta marcar al menos un campo de experiencia con adultos',
  mandatory_disabled_experience: 'Falta marcar al menos un campo de experiencia con discapacitados',
  mandatory_freelance: 'Selecciona si eres un autónomo',
  invalid_freelance_number: 'El número de la seguridad social es inválido',
  mandatory_mailing: 'Es necesario marcar si deseas que te llegue información o no',
  mandatory_personal_data:
    'Antes de rellenar los datos bancarios, hace falta que los datos personales estén rellenados',
  mandatory_id_type: 'Selecciona el tipo de documento de identificación',
  mandatory_id: 'El documento de identificación es obligatorio',
  mandatory_account_number: 'El número de cuenta es obligatorio',
  mandatory_address: 'La dirección es obligatoria',
  mandatory_postal_code: 'El código postal es obligatorio',
  mandatory_locality: 'La localidad es obligatoria',
  mandatory_province: 'La provincia es obligatoria',
  invalid_id_type: 'Selecciona el tipo de documento de identificación',
  invalid_id: 'El documento de identificación no es correcto. Revisa el número que has introducido',
  id_in_use: 'El documento de identidad ya está en uso',
  invalid_account_number: 'El número de cuenta no es correcto',
  invalid_postal_code: 'El código postal no es correcto',
  invalid_province: 'La provincia no es correcta',
  mandatory_cv_file: 'El fichero del currículum es obligatorio para poder introducirlo',
  mandatory_cv_name: 'Falta el nombre del fichero del currículum',
  invalid_file_format:
    'El formato del fichero de acreditación de experiencia es incorrecto; se aceptan ficheros con formato .pdf o .jpg',
  mandatory_experience_file: 'El fichero de acreditación de experiencia es obligatorio',
  mandatory_experience_file_name: 'El nombre del fichero de acreditación de experiencia es obligatorio',
  mandatory_reference_id: 'Es necesario el identificador de acreditación de experiencia para poder borrarla',
  invalid_parameter_type: 'El identificador de acreditación de experiencia tiene que ser un número',
  mandatory_qualification_type: 'El tipo de formación es obligatorio para introducir una nueva titulación',
  mandatory_qualification_specialty: 'La titulación es obligatoria',
  invalid_qualification_file_format:
    'El formato de fichero de titulación es incorrecto: se aceptan ficheros con formato .pdf o .jpg',
  invalid_qualification_type: 'El formato de tipo de formación es incorrecto',
  invalid_qualification_area: 'El formato de area es incorrecto',
  invalid_qualification_specialty: 'El formato de titulación es incorrecto',
  invalid_qualification_file_name: 'El formato de nombre de archivo incorrecto',
  invalid_qualification_file: 'Fichero de titulación inválido',
  invalid_qualification_name: 'Formato del nombre de la formación incorrecto',
  invalid_qualification_membership_number: 'Formato de número de colegiado incorrecto',
  invalid_qualification_medical_school: 'Formato del campo de colegio de médicos incorrecto',
  mandatory_activation:
    'Falta el estado de activación del perfil. Selecciona si deseas que el perfil esté activado o no',
  experience_file_size: 'El fichero de acreditación de experiencia no debe superar los 2MB',
  invalid_service_id:
    'Ha habido un error al procesar la recomendación. Envía una nueva solicitud y tendrás candidatos en menos de 1 hora',
  request_not_found:
    'Tu solicitud ha caducado y el profesional ya no está disponible. Envía una nueva solicitud y tendrás candidatos en menos de 1 hora',
  request_payment_cannot_be_authorized:
    'La solicitud no puede ser autorizada. Por favor, ponte en contacto con nosotros para que podamos resolverlo',
  coupon_code_already_exists: 'Oops! Este código ya existe. Prueba a crear otro diferente.',
  invalid_coupon_code: 'El código es invalido',
  mandatory_selected_plan: 'Hay que seleccionar un plan premium',
  mandatory_coupon_code: 'El código es obligatorio',
  mandatory_valid_plan: 'El plan premium no es valido',
  mandatory_max_redeems: 'El número limite de usos del código es obligatorio',
  mandatory_time_limit: 'El tiempo limite del código es obligatorio',
  mandatory_discount_percent: 'El porcentaje de descuento del código es obligatorio',
  includes_long_term:
    'Para confirmar la compra del Pack contacta con la coordinadora de los servicios de conciliación. No se te ha aplicado ningún cargo. Llama al 918 26 00 12 o escribe a serviciosconcilia@eulen.com. Te ayudará a gestionarlo.',
  coupon_code_not_found: 'Oops! El código no es válido. Comprueba que está bien escrito o introduce otro diferente.',
  failed_coupon_retrieve: 'Oops! El código no es válido. Comprueba que está bien escrito o introduce otro diferente.',
  coupon_redemptions_spent: 'Oops! Se ha alcanzado el límite de usos de este código. Prueba otro diferente.',
  coupon_code_expired: 'Oops! El código ha caducado. Prueba otro diferente.',
  incompatible_premium_plan: 'Oops! Este código no es válido para este Plan.',
  coupon_already_redeemed_by_user: 'Oops! Ya habías canjeado antes este código. Prueba con otro diferente.',
  user_has_already_used_a_coupon: 'Oops! Ya has canjedo un cupón. Solo se puede canjear un único cupón.',
  stripe_missing_token_error: 'El pago no ha podido ser autenticado',
  stripe_missing_payment_method:
    'El número de cuenta del representado no ha sido dado de alta en Stripe. Edita su cuenta para que se vuelvan a enviar los datos a Stripe',
  payment_setup_not_ready: 'El pago no ha podido ser autenticado',
  service_duplication:
    'Ya hemos recibido una solicitud tuya con la misma información. Puedes ir a tu área privada y comprobar que está en marcha',
  invalid_user:
    'Así podremos cargar tus datos correctamente y después podrás enviar tu solicitud de profesional. Perdona las molestias!',
  unauthorized: 'Inicia sesión con tu usuario de Familiados para poder continuar',
  internal_server_error:
    'Ha tenido lugar un error no previsto. Por favor, ponte en contacto con nosotros para que podamos resolverlo',
  mandatory_form: 'Falta información por rellenar. Revisa que todo está bien antes de guardar',
  invalid_address_document_file_format: 'El fichero no tiene el formato correcto',
  request_is_closed:
    'Vaya! Lo sentimos pero esta oferta ha caducado... Seguro que pronto recibes nuevas oportunidades. Mucha suerte! 🤗',
  non_available_caretaker: 'El profesional seleccionado no está disponible',
  caretaker_is_not_habilitated:
    'El profesional no está activado. Al activar el perfil podrás acceder a más funcionalidades.',
  mandatory_active_value_not_found: 'No hemos podído desactivar el perfil, intentalo más tarde',
  invalid_address_city_state_postal_code:
    'La combinación de ciudad y código postal de la dirección que has indicado no es válida',
  invalid_street_address: 'El nombre de la calle y/o el número de la dirección que has indicado no es válida',
  verification_document_address_mismatch:
    'La dirección del documento para verificar el domicilio no coincide con la dirección que has indicado en el apartado Dirección de domiciliación. Adjunta un nuevo documento o actualiza la dirección en dicho apartado',
  verification_document_corrupt:
    'El documento subido para verificar el domicilio no es válido o está corrupto. Sube un nuevo archivo',
  verification_document_country_not_supported:
    'El documento subido para verificar el domicilio es de un país no admitido',
  verification_document_dob_mismatch: 'La fecha de nacimiento no coincide  con la establecida en tu DNI',
  verification_document_duplicate_type:
    'No se puede utilizar el mismo tipo de documento para verificar identidad y domicilio. Adjunta dos documentos diferentes',
  verification_document_expired:
    'El documento utilizado para la verificación ha expirado. Para verificar la identidad es necesario un documento con fecha de expiración anterior a la fecha de subida. Para la verificación de domicilio la fecha puede estar dentro de los últimos 6 meses',
  verification_document_failed_copy:
    'No se ha podido verificar el documento por ser una copia. Adjunta el documento original',
  verification_document_failed_greyscale:
    'No se ha podido verificar el documento por estar en escala de grises. Adjunta una copia a color del documento',
  verification_document_fraudulent: 'Se ha identificado el documento como alterado o falsificado',
  verification_document_incomplete:
    'El documento subido está cortado o falta información importante. Sube el documento completo',
  verification_document_invalid: 'El documento subido no es válido. Adjunta un DNI o NIE para verificar la identidad',
  verification_document_manipulated: 'Se ha identificado el documento como alterado o falsificado',
  verification_document_missing_back: 'Falta la parte trasera del documento subido',
  verification_document_missing_front: 'Falta la parte delatera del documento subido',
  verification_document_name_mismatch:
    'El nombre del documento de identidad no coincide con el nombre de tu perfil. Sube un nuevo documento o actualiza el nombre de tu perfil',
  caretaker_not_enabled:
    'Hasta que no completes y activemos tu perfil, no puedes apuntarte a ofertas de trabajo en Familiados',
  caretaker_unverified: 'No puedes acceder hasta que no estés verificado',
  invalid_selected_plan: 'El plan seleccionado es invalido, prueba con otro',
  failed_subscription_creation: 'Ha ocurrido un error durante la suscripción. Intentalo más tarde',
  caretaker_qualification_not_allowed: 'No tienes la formación solicitada para inscribirte a esta oferta',
  pro_plan_already_active:
    'Ups! Parece que ya tienes una suscripción activa. Sigue disfrutando de todas las ventajas de ser PRO',
  default:
    'Ha tenido lugar un error no previsto. Por favor, ponte en contacto con nosotros para que podamos resolverlo',
  caretaker_can_not_search_for_job:
    'Búsqueda abierta es una funcionalidad exclusiva para familias que necesitan profesionales. Si estás buscando trabajo hazlo desde tu perfil de Familiados.',
  not_have_any_resident: 'Introduce algún residente en tu área privada para poder continuar',
  user_is_not_residence: 'Para acceder es necesario que seas un usuario de residencia',
  invalid_receiver:
    'Ha tenido lugar un error no previsto. Por favor, ponte en contacto con nosotros para que podamos resolverlo',
  lead_already_requested: 'Ya está tu petición en curso! Uno de nuestros expertos se pondrá en contacto contigo',
  mandatory_service_dates: 'Para poder realizar el pago hay que seleccionar correctamente los días',
  invalid_customer_user_type: 'El usuario no puede realizar este tipo de servicio',
  invalid_customer_user: 'El usuario no es el adecuado para solicitar el servicio',
  image_not_same: 'La foto ha sido modificada y no es la misma. Recarga y vuelve a intentarlo',
  mandatory_user_image_name: 'Ups. Algo ha ido mal. Vuelve a intentarlo',
  caretaker_is_not_allowed_to_work: 'Necesitas tener activado tu perfil para poder realizar esta acción',
  mandatory_verified_title:
    'A esta oferta solo pueden apuntarse candidatos con el perfil completo. Termina de completar tu perfil',
  mandatory_bank_data:
    'Este cliente solo acepta pagos realizados a través de Familiados. Completa el apartado de datos bancarios para poder apuntarte a la oferta',
  caretaker_not_available_to_residence:
    'Este centro solo acepta candidatos con formación o experiencia sociosanitaria. Si es tu caso, completa la información en tu perfil y vuelve a intentarlo.',
  chat_group_not_created:
    'En estos momentos no se puede acceder al chat de la oferta. Vuélvelo a intentar más tarde o ponte en contacto con nosotros',
  has_not_caretaker_active_account: 'Necesitas tener activado tu perfil para poder realizar esta acción',
  caretaker_has_not_minimum_work_requirements: 'Este profesional no está activado y no es posible realizar esta acción',
  has_not_caretaker_with_minimum_work_requirements_account:
    'Necesitas tener tu perfil activado para realizar esta acción. Completa tu perfil',
}



// WEBPACK FOOTER //
// ./src/views/components/Error/serverErrors.ts